import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SidebarTypes =
    | 'ABOUT'
    | 'APPMODELS'
    | 'PRICING'
    | 'LOGIN'
    | 'REGISTER'
    | 'SMALL_NAVBAR';
export type LayoutState = {
    leftOpen: boolean;
    rightOpen: boolean;
    sidebarType: SidebarTypes | undefined;
};
export const initialState: LayoutState = {
    leftOpen: false,
    rightOpen: false,
    sidebarType: undefined
};

const layoutSlice = createSlice({
    name: 'LayoutReducer',
    initialState,
    reducers: {
        openLeftSidebar(state, action: PayloadAction<{ sidebarType: SidebarTypes }>) {
            state.sidebarType = action.payload.sidebarType;
            state.leftOpen = true;
            state.rightOpen = false;
        },
        openRightSidebar(state, action: PayloadAction<{ sidebarType: SidebarTypes }>) {
            state.sidebarType = action.payload.sidebarType;
            state.rightOpen = true;
            state.leftOpen = false;
        },
        closeSidebar(state, ) {
            state.sidebarType = undefined;
            state.leftOpen = false;
            state.rightOpen = false;
        }
    }
});

export const reducer = layoutSlice.reducer;
export const { closeSidebar, openLeftSidebar, openRightSidebar } = layoutSlice.actions;
